"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require('lodash');

var _require = require('crypto-js'),
    AES = _require.AES,
    enc = _require.enc;

var _require2 = require('date-fns'),
    addWeeks = _require2.addWeeks;

var API_HOSTS_STORAGE_KEY = 'soul_sdk.api_hosts';
var API_HOSTS_TYPES = {
  centrifugoWsHost: 10,
  chatsWsHost: 11,
  apiHost: 12,
  // It's not used in the dns request, added here to compability
  goddessApiHost: 100
};
var API_HOSTS_TTL_KEY = 'ttl';

var ApiUrls =
/*#__PURE__*/
function () {
  function ApiUrls(_ref) {
    var _objectSpread2,
        _this = this;

    var testing = _ref.testing,
        dnsProvidersUrls = _ref.dnsProvidersUrls,
        apiDiscoveryHost = _ref.apiDiscoveryHost,
        apiKey = _ref.apiKey,
        apiHost = _ref.apiHost,
        chatWsHost = _ref.chatWsHost,
        centrifugoWsHost = _ref.centrifugoWsHost,
        goddessApiHost = _ref.goddessApiHost,
        sendAmplitudeEvent = _ref.sendAmplitudeEvent;

    _classCallCheck(this, ApiUrls);

    this._testing = testing;
    this._apiKey = apiKey;
    this._apiDiscoveryHost = apiDiscoveryHost;
    this._dnsProvidersUrls = dnsProvidersUrls;
    this._sendAmplitudeEvent = sendAmplitudeEvent;
    this._hosts = _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, API_HOSTS_TYPES.apiHost, apiHost), _defineProperty(_objectSpread2, API_HOSTS_TYPES.chatsWsHost, chatWsHost), _defineProperty(_objectSpread2, API_HOSTS_TYPES.centrifugoWsHost, centrifugoWsHost), _defineProperty(_objectSpread2, API_HOSTS_TYPES.goddessApiHost, goddessApiHost), _objectSpread2), this.getApiHostsFromStorage() || {});
    this._uncheckedDnsProviders = _.shuffle(dnsProvidersUrls);
    this.hostsRequested = false;
    this.online = true;
    window.addEventListener('online', function () {
      _this.online = true;
    });
    window.addEventListener('offline', function () {
      _this.online = false;
    });
  }

  _createClass(ApiUrls, [{
    key: "sendAmplitudeEvent",
    value: function sendAmplitudeEvent() {
      if (this._sendAmplitudeEvent && typeof this._sendAmplitudeEvent === 'function') {
        this._sendAmplitudeEvent.apply(this, arguments);
      }
    }
  }, {
    key: "getHttpsUrl",
    value: function getHttpsUrl(url) {
      var resolvedUrl = url;

      if (!resolvedUrl.startsWith('https://')) {
        resolvedUrl = "https://".concat(resolvedUrl);
      }

      resolvedUrl = this.removeUrlTruncDot(resolvedUrl);

      if (url.slice(-1) !== '/') {
        resolvedUrl += '/';
      }

      return resolvedUrl;
    }
  }, {
    key: "getWssUrl",
    value: function getWssUrl(url) {
      var resolvedUrl = url;

      if (!resolvedUrl.startsWith('wss://')) {
        resolvedUrl = "wss://".concat(resolvedUrl);
      }

      return this.removeUrlTruncDot(resolvedUrl);
    }
  }, {
    key: "removeUrlTruncDot",
    value: function removeUrlTruncDot(url) {
      var resolvedUrl = url;

      if (url.slice(-1) === '.') {
        resolvedUrl = resolvedUrl.slice(0, -1);
      }

      return resolvedUrl;
    }
  }, {
    key: "fetchApiHosts",
    value: function () {
      var _fetchApiHosts = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var success, dnsProviderUrl, _ret;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                success = false;
                this.hostsRequested = true;

                if (!(!this._apiDiscoveryHost || !this.online)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                this.sendAmplitudeEvent('API Switch started');

              case 5:
                dnsProviderUrl = this._uncheckedDnsProviders.pop();
                _context2.prev = 6;
                return _context2.delegateYield(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee() {
                  var resolvedUrl, res, highestPriority, parsedAnswer, resolvedHosts;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          resolvedUrl = new window.URL(dnsProviderUrl);
                          resolvedUrl.searchParams.set('name', _this2._apiDiscoveryHost);
                          resolvedUrl.searchParams.set('type', 'srv');
                          _context.next = 5;
                          return window.fetch(resolvedUrl.toString(), {
                            headers: {
                              accept: 'application/dns-json'
                            }
                          });

                        case 5:
                          res = _context.sent;
                          _context.next = 8;
                          return res.json();

                        case 8:
                          res = _context.sent;

                          if (!(res.Status !== 0)) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return", "continue");

                        case 11:
                          highestPriority = 1000;
                          parsedAnswer = res.Answer.map(function (answer) {
                            var values = answer.data.split(' ');
                            var priority = values[0];

                            if (priority < highestPriority) {
                              highestPriority = priority;
                            }

                            return {
                              priority: priority,
                              type: values[1],
                              host: values[3]
                            };
                          });
                          resolvedHosts = parsedAnswer.reduce(function (acc, item) {
                            if (!acc[item.type] && item.priority === highestPriority) {
                              acc[item.type] = item.host;
                            }

                            return acc;
                          }, {});

                          _this2.updateApiHosts(resolvedHosts); // Delay for amplitude event


                          _context.next = 17;
                          return new Promise(function (resolve) {
                            setTimeout(resolve, 1000);
                          });

                        case 17:
                          _this2.sendAmplitudeEvent('API Switch completed', {
                            api_host: _this2.removeUrlTruncDot(resolvedHosts[API_HOSTS_TYPES.apiHost]),
                            chat_host: _this2.removeUrlTruncDot(resolvedHosts[API_HOSTS_TYPES.chatsWsHost]),
                            centrifugo_host: _this2.removeUrlTruncDot(resolvedHosts[API_HOSTS_TYPES.centrifugoWsHost])
                          });

                          success = true;

                        case 19:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })(), "t0", 8);

              case 8:
                _ret = _context2.t0;

                if (!(_ret === "continue")) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("continue", 16);

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](6);
                console.error('FETCH API URL', _context2.t1);

              case 16:
                if (!success && this._uncheckedDnsProviders.length) {
                  _context2.next = 5;
                  break;
                }

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 13]]);
      }));

      function fetchApiHosts() {
        return _fetchApiHosts.apply(this, arguments);
      }

      return fetchApiHosts;
    }()
  }, {
    key: "getApiHostsFromStorage",
    value: function getApiHostsFromStorage() {
      var savedApiHosts = window.localStorage.getItem(API_HOSTS_STORAGE_KEY);

      if (savedApiHosts && this._apiDiscoveryHost) {
        try {
          var resolvedHosts = savedApiHosts;

          if (!this._testing) {
            resolvedHosts = AES.decrypt(savedApiHosts, this._apiKey);
            resolvedHosts = resolvedHosts.toString(enc.Utf8);
          }

          var hosts = JSON.parse(resolvedHosts);

          if (hosts && _typeof(hosts) === 'object') {
            var ttl = Number(hosts[API_HOSTS_TTL_KEY]);

            if (!ttl || ttl < Date.now()) {
              this.sendAmplitudeEvent('API Switch reverted');
              return null;
            }

            return hosts;
          }
        } catch (err) {
          window.localStorage.removeItem(API_HOSTS_STORAGE_KEY);
          console.error('PARSE API HOSTS', err);
        }
      }

      return null;
    }
  }, {
    key: "updateApiHosts",
    value: function updateApiHosts(hosts) {
      this._hosts = _objectSpread({}, this._hosts, hosts);
      var data = JSON.stringify(_objectSpread({}, this._hosts, _defineProperty({}, API_HOSTS_TTL_KEY, addWeeks(new Date(), 2).getTime())));
      var resolvedData = data;

      if (!this._testing) {
        resolvedData = AES.encrypt(data, this._apiKey).toString();
      }

      window.localStorage.setItem(API_HOSTS_STORAGE_KEY, resolvedData);
    }
  }, {
    key: "urls",
    get: function get() {
      return {
        apiEndpoint: this.getHttpsUrl(this._hosts[API_HOSTS_TYPES.apiHost]),
        chatWsUrl: "".concat(this.getWssUrl(this._hosts[API_HOSTS_TYPES.chatsWsHost]), "/chats-service/v1/ws/"),
        centrifugoWsUrl: "".concat(this.getWssUrl(this._hosts[API_HOSTS_TYPES.centrifugoWsHost]), ":443/connection/websocket"),
        goddessApiUrl: this.getHttpsUrl(this._hosts[API_HOSTS_TYPES.goddessApiHost])
      };
    }
  }]);

  return ApiUrls;
}();

module.exports = ApiUrls;